<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :modalBodyClass="$prefixClass.modal + '-confirm'"
    >
        <div>
            <p>{{$t('optimize_image.modal_publish_theme.content')}}</p>
        </div>

        <div class="text-center" slot="footer">
            <a-button type="default" @click="needHelp">{{$t('optimize_image.modal_publish_theme.need_help')}}</a-button>
            <a-button type="primary" @click="publishNow">{{$t('optimize_image.modal_publish_theme.publish_now')}}</a-button>
        </div>
    </vue-modal>
</template>
<script>
import { store } from '@/main.js'

export default {
    name: 'ModalPublishTheme',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit(this.value)
            }
        }
    },
    watch: {
        modal: {
            async handler(val) {
                if (!val.isVisible) {
                    store.commit('setShowPreviewTheme', false)
                }
            },
            deep: true
        },
    },
    created() {
    },
    methods: {
        needHelp() { 
            this.modal.isVisible = false;
            this.$emit('do-contact');
        },

        publishNow() {
            this.modal.isVisible = false;
            this.$emit('publish-now');
        }
    }
}
</script>
<style lang="scss">
    .#{$modal}-confirm {
        width: 420px !important;
        .#{$modal} {
            &-body {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 133px;
                p {
                    margin-bottom: 0;
                }
            }
            &-footer {
                padding: 16px;
            }
        }
    }
</style>